module.exports = __webpack_public_path__ + "static/green_dragon_meets_bard-a230f7fd539b7f1de194f1b018451fc1.jpg";